<template>
  <el-dialog
    append-to-body
    v-dialogDrag
    :title="`${$t(title)}`"
    class="small-dialog"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    @close="closeDialog"
  >
    <el-form
      :model="form"
      :rules="rules"
      ref="form"
      label-width="150px"
      class="short-term-form"
      :disabled="disabled"
    >
      <el-form-item :label="`${$t('承包商单位名称')}`" prop="name">
        <el-input
          v-model="form.name"
          :placeholder="`${$t('请输入')}`"
          :maxlength="50"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item :label="`${$t('承包商单位简称')}`" prop="abbreviation">
        <el-input
          v-model="form.abbreviation"
          :placeholder="`${$t('请输入')}`"
          :maxlength="50"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item :label="`${$t('在厂周期')}`" prop="period">
        <el-date-picker
          v-model="form.period"
          type="daterange"
          size="small"
          range-separator="至"
          :start-placeholder="`${$t('开始日期')}`"
          :end-placeholder="`${$t('结束日期')}`"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          :disabled="form.isDelay"
        ></el-date-picker>
      </el-form-item>
      <el-form-item :label="`${$t('承包商单位负责人')}`" prop="leaderName">
        <el-input
          v-model="form.leaderName"
          :placeholder="`${$t('请输入')}`"
          :maxlength="50"
          show-word-limit
          @blur="validateLeaderAccount"
        ></el-input>
      </el-form-item>
      <el-form-item :label="`${$t('联系电话')}`" prop="phoneNumber">
        <el-input
          v-model="form.phoneNumber"
          :placeholder="`${$t('请输入')}`"
          :maxlength="50"
          show-word-limit
          @blur="validateLeaderAccount"
        ></el-input>
      </el-form-item>
      <el-form-item :label="`${$t('个人账号')}`" prop="leaderAccount">
        <div slot="label" class="inline-block">
          <el-tooltip
            content="请联系相关专业主管,确认账号开通格式,否则将无法审批通过"
            placement="top"
            effect="dark"
          >
            <span class="iconfont icon-bg-circleInfo mr-5px"></span>
          </el-tooltip>
          <span>{{ $t('个人账号') }}</span>
        </div>
        <el-input
          v-model="form.leaderAccount"
          :placeholder="`${$t('请输入')}`"
          :maxlength="50"
          show-word-limit
          :disabled="disabled || disabledAccount"
        ></el-input>
      </el-form-item>
      <el-form-item :label="`${$t('身份证号码')}`" prop="leaderIdCard">
        <el-input v-model="form.leaderIdCard" :placeholder="`${$t('请输入')}`"></el-input>
      </el-form-item>
      <el-form-item :label="`${$t('邮箱')}`" prop="email">
        <el-input
          v-model="form.email"
          :placeholder="`${$t('请输入')}`"
          show-word-limit
          maxlength="50"
        ></el-input>
      </el-form-item>
      <el-form-item label="所属专业" prop="ownerdSpecialtyId">
        <el-select
          v-model="form.ownerdSpecialtyId"
          filterable
          placeholder="请选择所属专业"
          clearable
        >
          <el-option
            v-for="item in specialtyList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="text-center" v-if="!['read'].includes(this.mode)">
      <el-button size="small" type="primary" @click="save('save')" :loading="loading"
        >保存</el-button
      >
      <el-button
        size="small"
        type="primary"
        @click="save('submit')"
        :loading="loading"
        v-if="
          [0, 3].includes(form.approvalStatus) || ([2].includes(form.approvalStatus) && form.taskId)
        "
        >提交</el-button
      >
      <el-button size="small" @click="closeDialog()">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { pick } from 'lodash'
import { SpecialtyApi } from '@wiz-api/team-management'
import { PeriodContractorApi } from '@wiz-api/contractor-management'
import { EafUserQueryApi } from '@wiz-api/account'
import dayjs from 'dayjs'
import clearPlaceholder from '@/assets/js/safety/ClearPlaceholder'

const specialtyApi = new SpecialtyApi()
const periodContractorApi = new PeriodContractorApi()
const eafUserQueryApi = new EafUserQueryApi()
const validatePhone = (rule, value, callback) => {
  if (!value) {
    callback(new Error('手机号不能为空'))
    return
  }
  const reg = /^1[3-9]{1}[0-9]{9}$/
  if (!reg.test(value)) {
    callback(new Error('请填写正确的手机号'))
    return
  }
  callback()
}

// 身份证验证
const validateCard = (rule, value, callback) => {
  const reg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
  if (!value) {
    callback(new Error('请输入身份证号码'))
  } else if (reg.test(value)) {
    callback()
  } else {
    callback(new Error('请输入正确的身份证号码'))
  }
}

// 姓名校验
const validateName = (rule, value, callback) => {
  // 中文
  const reg = /^[a-zA-Z]+$|^[\u4E00-\u9FA5]+$/
  if (!value) {
    callback(new Error('请输入姓名'))
  } else if (!reg.test(value)) {
    callback(new Error('姓名只能全中文或者全英文'))
  } else {
    callback()
  }
}
const validateAccount = (rule, value, callback) => {
  const orderRule = /^[a-zA-Z0-9]+$/
  if (!value) {
    callback(new Error('请输入个人账号'))
  } else if (!orderRule.test(value)) {
    callback(new Error('请输入英文或数字'))
  } else {
    callback()
  }
}

export default {
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: 'read',
    },
    id: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      form: {
        period: [],
      },
      specialtyList: [],
      rules: {
        name: [{ required: true, message: '请输入承包商单位名称', trigger: ['blur'] }],
        abbreviation: [{ required: true, message: '请输入承包商单位简称', trigger: ['blur'] }],
        leaderName: [{ required: true, validator: validateName, trigger: ['blur', 'change'] }],
        phoneNumber: [{ required: true, validator: validatePhone, trigger: ['blur', 'change'] }],
        leaderAccount: [
          { required: true, validator: validateAccount, trigger: ['blur', 'change'] },
        ],
        period: [{ required: true, message: '请选择在厂周期', trigger: ['change'] }],
        ownerdSpecialtyId: [
          { required: true, message: '请选择所属专业', trigger: ['blur', 'change'] },
        ],
        email: [
          {
            required: false,
            message: '请输入邮箱',
            trigger: 'blur',
          },
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: ['blur', 'change'],
          },
        ],
        leaderIdCard: [{ required: true, validator: validateCard, trigger: ['blur', 'change'] }],
      },
      loading: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 86400000
        },
      },
      disabledAccount: false,
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
    title() {
      const modeObj = {
        create: '新增',
        update: '编辑',
        read: '查看',
      }
      return `${modeObj[this.mode]}短期承包商`
    },
    disabled() {
      return ['read'].includes(this.mode)
    },
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        if (this.disabled) {
          this.$nextTick(() => {
            clearPlaceholder('.short-term-form')
          })
        }
        if (this.mode !== 'create') {
          this.getDetail()
        }
      }
    },
  },
  methods: {
    async validateLeaderAccount() {
      this.disabledAccount = false
      if (this.form.leaderName && this.form.phoneNumber) {
        const [err, res] = await eafUserQueryApi.getEafUserByNameAndPhone({
          name: this.form.leaderName,
          phone: this.form.phoneNumber,
        })
        if (!err && res) {
          this.$set(this.form, 'leaderAccount', res.userName)
          this.$set(this.form, 'leaderId', res.id)
          this.disabledAccount = true
        }
      }
    },
    async getSpecialtyList() {
      const [err, res] = await specialtyApi.getSpecialtyDropDown()
      if (!err) {
        this.specialtyList = res
      }
    },
    async getDetail() {
      const [err, res] = await periodContractorApi.getInfo(this.id)
      if (!err) {
        this.form = {
          ...res,
          period: [
            dayjs(res.startDate).format('YYYY-MM-DD'),
            dayjs(res.endDate).format('YYYY-MM-DD'),
          ],
        }
        this.validateLeaderAccount()
      }
    },
    save(type) {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.loading = true
          let apiRes = []
          let msgType = ''
          const body = pick(this.form, [
            'name',
            'abbreviation',
            'leaderName',
            'phoneNumber',
            'leaderAccount',
            'ownerdSpecialtyId',
            'email',
            'leaderIdCard',
          ])
          if (this.disabledAccount) {
            body.leaderId = this.form.leaderId
          }
          body.startDate = dayjs(this.form.period[0]).format('YYYY-MM-DD 00:00:00')
          body.endDate = dayjs(this.form.period[1]).format('YYYY-MM-DD 23:59:59')
          if (type === 'submit') {
            msgType = '提交'
            body.id = this.form.id || null
            // 驳回调审批接口
            if (this.form.approvalStatus === 2) {
              await periodContractorApi.update(this.form.id, {
                body: {
                  ...this.form,
                  ...body,
                },
              })
              apiRes = await periodContractorApi[this.form.isDelay ? 'delayApprove' : 'approve']({
                body: {
                  id: this.form.id,
                  isPass: true,
                  approve: '',
                  taskId: this.form.taskId,
                },
              })
            } else if (this.form.isDelay) {
              await periodContractorApi.update(this.form.id, {
                body: {
                  ...this.form,
                  ...body,
                },
              })
              apiRes = await periodContractorApi.delaySave({
                body: {
                  id: this.form.id,
                  delayTime: dayjs(this.form.delayTime).format('YYYY-MM-DD HH:mm:ss'),
                  delayReason: this.form.delayReason,
                  isSubmit: true,
                },
              })
            } else {
              apiRes = await periodContractorApi.submit({
                body,
              })
            }
          } else if (this.mode === 'create') {
            msgType = '新增'
            apiRes = await periodContractorApi.create({
              body,
            })
          } else {
            msgType = '编辑'
            body.id = this.form.id
            apiRes = await periodContractorApi.update(this.form.id, {
              body: {
                ...this.form,
                ...body,
              },
            })
          }
          this.loading = false
          if (!apiRes[0]) {
            this.$message.success(`${msgType}成功！`)
            this.$emit('save')
            this.closeDialog()
          }
        }
      })
    },
    submit() {
      this.loading = true
    },
    closeDialog(done) {
      this.form = this.$options.data().form
      this.disabledAccount = false
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
        if (done) {
          done()
        } else {
          this.dialogVisible = false
        }
      })
    },
  },
  created() {
    this.getSpecialtyList()
  },
}
</script>

<style lang="scss" scoped></style>
